import { Select } from '@hotjar/hotsauce';
import { useTranslation } from 'react-i18next';

import type { Site } from '@hotjar/site';

interface IntegrationsSiteDropdownProps {
  sites: Site[];
  onChange: (value: string) => void;
  value: number;
}

export const IntegrationSiteDropdown = ({
  sites,
  onChange,
  value,
}: IntegrationsSiteDropdownProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Select
      aria-label={t('integrations:page.dropdown-title')}
      value={value}
      size="l"
      onChange={(e) => onChange(e.target.value)}
    >
      {sites.map((site) => (
        <option key={site.id} value={site.id}>
          {site.name}
        </option>
      ))}
    </Select>
  );
};
